import React, { useState } from 'react';
import {Form, Textarea, Button} from "@heroui/react";
import {
  Table,
  TableColumn,
  TableHeader,
  TableBody,
  TableRow,
  TableCell
} from "@heroui/table";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@heroui/modal";

const CompletionModal = ({campaign, dismissModal}) => {
  const [completionText, setCompletionText] = useState();

  const submitCompletion = async () => {
    // Do validations
    //
    // Post the completion
    const fd = new FormData();
    if (completionText && completionText !== '') {
      fd.append('completion_text', completionText);
    }
    const d = await fetch(`/api/v1/campaign/${campaign._id}/complete`, {method: 'PUT', body: fd});
    if (d?.status !== 200) {
      alert('Error posting completion: ' + d?.error);
    } else {
      alert('Completion posted successfully.');
      window.location.href = '/';
    }
  };

  return (
    <Form onSubmit={submitCompletion}>
      <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>
            End campaign "{campaign.subject}"
          </ModalHeader>
          <ModalBody>
            <Table aria-label="Settings" color='danger' shadow="md">
              <TableHeader style={{height: '0px', padding: '0px', margin: '0px'}} columns={2}>
                <TableColumn style={{height: '0px'}}> </TableColumn>
                <TableColumn style={{height: '0px'}}> </TableColumn>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell className='htr'>Clicks:</TableCell>
                  <TableCell className='htr'>{campaign.usage_counter}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className='htr'>Emails: </TableCell>
                  <TableCell className='htr'>{campaign.email_record_count || "0"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className='htr'>Created: </TableCell>
                  <TableCell className='htr'>{new Date(campaign.created_at).toDateString().split(' ').slice(1, 4).join(' ')}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div style={{verticalAlign: 'top', width: '408px', marginBottom: '15px', marginLeft: '-5px', display: 'inline-block', padding: '4px'}}>
              <Textarea validationBehavior='aria'
                        variant='bordered'
                        disableAutosize
                        disableAnimation
                        classNames={{base: 'max-w-[800px]', input: 'resize-y min-h-[40px]'}}
                        minLength='8'
                        label='Completion / ThankYou Message'
                        defaultValue=''
                        size='lg'
                        onChange={(d) => setCompletionText(d.target.value)}
              />
            </div>
            <div style={{position: 'absolute', bottom: '15px', right: '22px'}}>
              <Button type='submit' size='sm' onPress={() => submitCompletion()}>End Campaign</Button>
            </div>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Form>
  );
}

export default CompletionModal;
